/* ASTROLIFT — Radian-style interactions */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const once = (el, key) => { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

  function money(cents) {
    const cur = window.arCurrency || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }

  /* Demo reference media: only in the theme editor or when previewing an unpublished theme. Never on the live theme. */
  function demoAllowed() {
    const S = window.Shopify || {};
    if (window.arDemoLive || S.designMode) return true;
    return !!(S.theme && S.theme.role && S.theme.role !== 'main');
  }
  function initDemo(root) {
    if (!demoAllowed()) return;
    root.querySelectorAll('[data-ar-demo-src]').forEach((el) => {
      if (el.dataset.arDemoSrcset) el.srcset = el.dataset.arDemoSrcset;
      el.src = el.dataset.arDemoSrc;
      el.removeAttribute('data-ar-demo-src');
      el.hidden = false;
      const ph = el.parentElement && el.parentElement.querySelector(':scope > .ar-demo-ph');
      if (ph) ph.remove();
      if (el.tagName === 'VIDEO' && el.autoplay) { const p = el.play(); if (p && p.catch) p.catch(() => {}); }
    });
  }

  function initReveal(root) {
    const items = root.querySelectorAll('.ar-reveal:not(.is-visible), .astro-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window) || reduceMotion) { items.forEach((el) => el.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    items.forEach((el) => io.observe(el));
  }

  /* Heading highlights: drawn once the heading reaches the upper part of the screen (Radian timing) */
  function initMarks(root) {
    const marks = root.querySelectorAll('.ar-mark:not(.is-drawn)');
    if (!('IntersectionObserver' in window) || reduceMotion || (window.Shopify && Shopify.designMode)) { marks.forEach((m) => m.classList.add('is-drawn')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-drawn'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -35% 0px', threshold: 0.2 });
    marks.forEach((m) => io.observe(m));
  }

  /* Scroll media effects: data-ar-scroll="zoom_in|zoom_out|parallax" + data-ar-visual children */
  const scrollers = new Set();
  let scrollFrame = 0;
  function updateScrollers() {
    scrollFrame = 0;
    const vh = window.innerHeight;
    scrollers.forEach((el) => {
      if (!el.isConnected) { scrollers.delete(el); return; }
      const rect = el.getBoundingClientRect();
      if (rect.bottom < -50 || rect.top > vh + 50) return;
      const progress = Math.min(Math.max((vh - rect.top) / Math.max(vh + rect.height, 1), 0), 1);
      const effect = el.dataset.arScroll;
      const speed = Math.min(Math.max(parseFloat(el.dataset.arSpeed) || 12, 1), 30);
      const zoom = Math.max(parseFloat(el.dataset.arZoom) || 1.2, 1);
      let ty = 0, sc = 1;
      if (effect === 'parallax') { ty = speed / 2 - progress * speed; sc = 1 + speed / 100; }
      else if (effect === 'zoom_in') sc = 1 + progress * (zoom - 1);
      else if (effect === 'zoom_out') sc = zoom - progress * (zoom - 1);
      el.style.setProperty('--ar-ty', ty.toFixed(3) + '%');
      el.style.setProperty('--ar-sc', sc.toFixed(4));
    });
  }
  function requestScrollers() { if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScrollers); }
  function initScroll(root) {
    if (reduceMotion) return;
    root.querySelectorAll('[data-ar-scroll]').forEach((el) => scrollers.add(el));
    if (scrollers.size && !initScroll.bound) {
      initScroll.bound = true;
      window.addEventListener('scroll', requestScrollers, { passive: true });
      window.addEventListener('resize', requestScrollers, { passive: true });
    }
    requestScrollers();
  }

  function initStars(canvas) {
    if (!once(canvas, 'ready')) return;
    const ctx = canvas.getContext('2d');
    const density = parseFloat(canvas.dataset.density || '1');
    let stars = [], w, h;
    function resize() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.offsetWidth; h = canvas.offsetHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const count = Math.round(((w * h) / 22000) * density);
      stars = Array.from({ length: count }, () => ({ x: Math.random() * w, y: Math.random() * h, r: Math.random() * 0.9 + 0.3, t: Math.random() * 6.28, s: Math.random() * 0.012 + 0.004 }));
    }
    function draw() {
      ctx.clearRect(0, 0, w, h);
      for (const st of stars) {
        st.t += st.s;
        ctx.beginPath();
        ctx.arc(st.x, st.y, st.r, 0, 6.2832);
        ctx.fillStyle = `rgba(255,255,255,${0.25 + (Math.sin(st.t) + 1) * 0.3})`;
        ctx.fill();
      }
      if (!reduceMotion) requestAnimationFrame(draw);
    }
    resize(); draw();
    window.addEventListener('resize', resize);
  }

  function initCountdown(el) {
    if (!once(el, 'ready')) return;
    const end = new Date(el.dataset.end).getTime();
    if (isNaN(end)) return;
    const q = (k) => el.querySelector(`[data-${k}]`);
    const parts = { d: q('d'), h: q('h'), m: q('m'), s: q('s') };
    const pad = (n) => String(n).padStart(2, '0');
    function tick() {
      let diff = Math.max(0, end - Date.now()) / 1000;
      const d = Math.floor(diff / 86400); diff -= d * 86400;
      const h = Math.floor(diff / 3600); diff -= h * 3600;
      const m = Math.floor(diff / 60); const s = Math.floor(diff - m * 60);
      if (parts.d) parts.d.textContent = pad(d);
      if (parts.h) parts.h.textContent = pad(h);
      if (parts.m) parts.m.textContent = pad(m);
      if (parts.s) parts.s.textContent = pad(s);
    }
    tick(); setInterval(tick, 1000);
  }

  function initTabs(wrap) {
    if (!once(wrap, 'tabs')) return;
    const buttons = wrap.querySelectorAll('[data-ar-tab]');
    const panels = wrap.querySelectorAll('[data-ar-panel]');
    buttons.forEach((btn) => btn.addEventListener('click', () => {
      buttons.forEach((b) => b.setAttribute('aria-selected', b === btn ? 'true' : 'false'));
      panels.forEach((p) => { p.hidden = p.dataset.arPanel !== btn.dataset.arTab; });
    }));
  }

  function initCarousel(wrap) {
    if (!once(wrap, 'carousel')) return;
    const visibleTrack = () => [...wrap.querySelectorAll('[data-ar-track]')].find((t) => t.offsetParent !== null);
    const go = (dir) => { const t = visibleTrack(); if (t) t.scrollBy({ left: dir * t.clientWidth * 0.75 }); };
    wrap.querySelectorAll('[data-ar-prev]').forEach((b) => b.addEventListener('click', () => go(-1)));
    wrap.querySelectorAll('[data-ar-next]').forEach((b) => b.addEventListener('click', () => go(1)));
  }

  function initQuotes(wrap) {
    if (!once(wrap, 'quotes')) return;
    const slides = wrap.querySelectorAll('[data-ar-slide]');
    const dots = wrap.querySelectorAll('[data-ar-dot]');
    if (!slides.length) return;
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const prev = wrap.querySelector('[data-ar-qprev]');
    const next = wrap.querySelector('[data-ar-qnext]');
    if (prev) prev.addEventListener('click', () => show(i - 1));
    if (next) next.addEventListener('click', () => show(i + 1));
    dots.forEach((d, k) => d.addEventListener('click', () => show(k)));
    show(0);
  }

  function initCompare(wrap) {
    if (!once(wrap, 'compare')) return;
    const input = wrap.querySelector('input[type=range]');
    const set = () => wrap.style.setProperty('--pos', input.value + '%');
    input.addEventListener('input', set); set();
  }

  function initBundle(wrap) {
    if (!once(wrap, 'bundle')) return;
    const pct = parseFloat(wrap.dataset.discount || '0');
    const items = [...wrap.querySelectorAll('[data-ar-bitem]')];
    const out = (k) => wrap.querySelector(`[data-ar-b${k}]`);
    function update() {
      let n = 0, total = 0;
      items.forEach((it) => {
        const on = it.querySelector('[data-ar-binc]').checked;
        it.classList.toggle('is-off', !on);
        if (!on) return;
        const sel = it.querySelector('select');
        const opt = sel ? sel.selectedOptions[0] : null;
        n += 1; total += parseInt((opt && opt.dataset.price) || it.dataset.price || '0', 10);
      });
      const save = Math.round(total * pct / 100);
      out('count').textContent = `${n} / ${items.length}`;
      out('orig').textContent = money(total);
      out('save').textContent = '-' + money(save);
      out('total').textContent = money(total - save);
      out('btn').disabled = n === 0;
    }
    items.forEach((it) => it.addEventListener('change', update));
    out('btn').addEventListener('click', async () => {
      const payload = items.filter((it) => it.querySelector('[data-ar-binc]').checked)
        .map((it) => { const sel = it.querySelector('select'); return { id: parseInt(sel ? sel.value : '0', 10), quantity: 1 }; })
        .filter((x) => x.id);
      if (!payload.length) return;
      out('btn').disabled = true;
      await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: payload })
      });
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    });
    update();
  }

  function initProduct(wrap) {
    if (!once(wrap, 'product')) return;
    const data = wrap.querySelector('script[data-ar-variants]');
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const idInput = wrap.querySelector('input[name=id]');
    const price = wrap.querySelector('[data-ar-price]');
    const btn = wrap.querySelector('[data-ar-add]');
    function update() {
      const groups = [...wrap.querySelectorAll('[data-ar-option]')];
      const chosen = groups.map((g) => (g.querySelector('input:checked') || {}).value);
      groups.forEach((g, k) => { const l = g.querySelector('[data-ar-optval]'); if (l) l.textContent = chosen[k] || ''; });
      const v = variants.find((x) => x.options.every((o, k) => o === chosen[k]));
      if (!v) { btn.disabled = true; return; }
      idInput.value = v.id;
      if (price) price.textContent = money(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
    }
    wrap.addEventListener('change', update);
    update();
  }

  function initHeader() {
    const drawer = document.querySelector('[data-ar-drawer]');
    if (drawer && once(drawer, 'drawer')) {
      const open = () => { drawer.hidden = false; document.body.classList.add('ar-lock'); };
      const close = () => { drawer.hidden = true; document.body.classList.remove('ar-lock'); };
      document.querySelectorAll('[data-ar-menu-open]').forEach((b) => b.addEventListener('click', open));
      drawer.querySelectorAll('[data-ar-menu-close]').forEach((b) => b.addEventListener('click', close));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }
    const top = document.querySelector('[data-ar-top]');
    if (top && once(top, 'top')) {
      window.addEventListener('scroll', () => top.classList.toggle('is-on', window.scrollY > 800), { passive: true });
      top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    }
  }

  /* ---------- Add to cart like Radian: check + burst on the button, product image flies into the bag ---------- */
  const shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const ATC_ICON = '<span class="atc-animation__added" aria-hidden="true"><span class="atc-animation__added-icon"><svg class="atc-animation__checkmark-burst" viewBox="0 0 24 24" fill="none"><g class="atc-animation__check"><circle class="atc-animation__ring" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path class="atc-animation__tick" d="M9 12.75L11.25 15L15 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><g class="atc-animation__burst">' +
    [0, 1, 2, 3, 4, 5, 6, 7].map((i) => '<g style="--atc-i: ' + i + ';"><line class="atc-animation__line" stroke-linecap="round" pathLength="1" x1="12" y1="8.5" x2="12" y2="15.5" stroke="currentColor"/></g>').join('') +
    '</g></svg></span></span>';

  function atcButton(btn) {
    if (!btn.hasAttribute('data-atc-animation-button')) {
      btn.setAttribute('data-atc-animation-button', '');
      btn.insertAdjacentHTML('beforeend', ATC_ICON);
    }
    clearTimeout(btn.arAtcTimer);
    btn.removeAttribute('data-atc-animation-active');
    void btn.offsetWidth;
    btn.setAttribute('data-atc-animation-active', 'true');
    btn.arAtcTimer = setTimeout(() => btn.removeAttribute('data-atc-animation-active'), 1785);
  }

  function cartTarget() {
    const icons = document.querySelectorAll('.ar-nav__cart svg, .ar-nav__cart');
    for (const el of icons) { const r = el.getBoundingClientRect(); if (r.width > 0 && r.height > 0) return el; }
    return null;
  }

  function flyToCart(source, imageUrl, qty) {
    const dest = cartTarget();
    if (reduceMotion || !dest || !source || !imageUrl) return 0;
    const a = source.getBoundingClientRect();
    const b = dest.getBoundingClientRect();
    const sx = a.left + a.width / 2, sy = a.top + a.height / 2;
    const fly = document.createElement('div');
    fly.className = 'ar-fly';
    fly.setAttribute('aria-hidden', 'true');
    fly.style.backgroundImage = 'url("' + String(imageUrl).replace(/"/g, '') + '")';
    fly.style.setProperty('--sx', sx + 'px');
    fly.style.setProperty('--sy', sy + 'px');
    fly.style.setProperty('--tx', (b.left + b.width / 2 - sx) + 'px');
    fly.style.setProperty('--ty', (b.top + b.height / 2 - sy) + 'px');
    if (qty > 1) { const q = document.createElement('span'); q.className = 'ar-fly__qty'; q.textContent = qty; fly.appendChild(q); }
    document.body.appendChild(fly);
    setTimeout(() => fly.remove(), 700);
    return 600;
  }

  function productImage(form) {
    const scope = form.closest('[data-ar-pdp], .ar-card, .product, .shopify-section') || document;
    const el = scope.querySelector('.ar-pdp__slide.is-active img:not([hidden]), .ar-pdp__slide.is-active video, img:not([hidden])');
    if (!el) return '';
    return el.tagName === 'VIDEO' ? (el.poster || '') : (el.currentSrc || el.src || '');
  }

  function refreshCount() {
    fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => {
        document.querySelectorAll('[data-ar-count]').forEach((badge) => {
          if (String(c.item_count) !== badge.textContent && c.item_count > 0) {
            badge.classList.add('is-bump');
            setTimeout(() => badge.classList.remove('is-bump'), 350);
          }
          badge.textContent = c.item_count;
          badge.hidden = c.item_count === 0;
        });
        document.querySelectorAll('[data-ar-cart-count]').forEach((el) => { el.textContent = c.item_count; });
      })
      .catch(() => {});
  }

  /* Radian sequence: the animation starts on click (check on the button + image flying to the bag) while the
     line is being added; as soon as Shopify confirms, the cart drawer slides in (with its thin loading bar).
     Runs before the header's own listener (window capture). */
  window.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f || !f.getAttribute || (f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    const ret = f.querySelector('[name="return_to"]');
    if (ret && !ret.disabled && ret.value) return; /* "Acheter maintenant" goes straight to checkout */
    e.preventDefault();
    e.stopImmediatePropagation();
    const sub = e.submitter && !e.submitter.hasAttribute('data-ar-buynow') ? e.submitter : null;
    const btn = sub || f.querySelector('[type="submit"]:not([data-ar-buynow])');
    if (btn && btn.disabled) return;
    const qty = parseInt((f.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    if (btn) { atcButton(btn); btn.setAttribute('aria-busy', 'true'); }
    flyToCart(btn || f, productImage(f), qty);
    fetch(shopRoot + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then((res) => {
        if (btn) btn.removeAttribute('aria-busy');
        if (!res.ok) {
          if (btn) { clearTimeout(btn.arAtcTimer); btn.removeAttribute('data-atc-animation-active'); }
          alert(res.j.description || res.j.message || 'Impossible d’ajouter ce produit.');
          return;
        }
        refreshCount();
        const drawer = document.querySelector('[data-ar-cart]');
        if (drawer) {
          drawer.classList.add('is-loading');
          setTimeout(() => drawer.classList.remove('is-loading'), 700);
          document.dispatchEvent(new CustomEvent('ar:cart:open'));
        }
      })
      .catch(() => { if (btn) btn.removeAttribute('aria-busy'); f.submit(); });
  }, true);

  function initAll(root) {
    initDemo(root);
    initReveal(root);
    initMarks(root);
    initScroll(root);
    root.querySelectorAll('canvas[data-ar-stars], canvas[data-astro-stars]').forEach(initStars);
    root.querySelectorAll('[data-ar-countdown]').forEach(initCountdown);
    root.querySelectorAll('[data-ar-tabs]').forEach(initTabs);
    root.querySelectorAll('[data-ar-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-ar-quotes]').forEach(initQuotes);
    root.querySelectorAll('[data-ar-compare]').forEach(initCompare);
    root.querySelectorAll('[data-ar-bundle]').forEach(initBundle);
    root.querySelectorAll('[data-ar-product]').forEach(initProduct);
    initHeader();
  }

  window.arInitDemo = initDemo;
  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
